import React, { useEffect } from 'react'
import omit from 'lodash/omit'
import isEqual from 'lodash/isEqual'
import { Link, useHistory, useParams } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks'
import { FadeIn } from 'lib/ui/components'
import { AddressInput } from 'lib/types/core'
import { Title } from '../../../../components/Styled'
import { AddressForm } from '../../components/AddressForm'
import { FormContainer } from '../../components/Styled'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { useCustomerAddress, useSetDefaultShippingAddressOnCart } from 'hooks/customerAddress'

export const Edit = () => {
  const { customer } = useCustomer()
  const history = useHistory()
  const params = useParams<{ id: string }>()
  const id = parseInt(params.id)
  const customerAddress = customer?.addresses.find(address => address.id === id)
  const { updateAddress, createAddress, isFetching } = useCustomerAddress()
  const { updateCheckoutAddress } = useSetDefaultShippingAddressOnCart()

  const handleSubmit = ({ address }: { address: AddressInput}) => {
    const isDefaultShipping = customerAddress?.isDefaultShipping
    const isDefaultBilling = customerAddress?.isDefaultBilling
    const addressHasNoChanges = isEqual(omit(address, ['regionId', 'region', 'isDefaultShipping', 'isDefaultBilling']), omit(customerAddress, ['id', 'regionLabel', 'isDefaultShipping', 'isDefaultBilling']))
    // eslint-disable-next-line
    if ((isDefaultBilling && isDefaultShipping) && (!address.isDefaultBilling || !address.isDefaultShipping) && !addressHasNoChanges) {
      createAddress({ address }).then(() => updateCheckoutAddress(address))
    } else {
      updateAddress({ id, address }).then(() => updateCheckoutAddress(address))
    }
  }

  useEffect(() => {
    if (!customerAddress) {
      history.push('/customer/account/addresses')
    }
  }, [
    customerAddress,
    history
  ])

  return (
    <FadeIn>
      <FormContainer>
        <div>
          <FlexWrapper className='flex-title'>
            <Title>
              Edit Address Information
            </Title>
            <Link to='/customer/account'>Back</Link>
          </FlexWrapper>

          {customerAddress && (
            <AddressForm
              address={customerAddress}
              onSubmit={handleSubmit}
              isFetching={isFetching}
            />
          )}
        </div>
      </FormContainer>
    </FadeIn>
  )
}
